import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ScreenSearchDesktopIcon(props: IconProps) {
    return <Icon {...props} iconKey={"screen_search_desktop"}/>
}
